import { NgModule } from '@angular/core';
import { UserDropdownMenuComponent } from './user-dropdown-menu.component';
import { RouterModule, Routes } from '@angular/router';

@NgModule({
  imports: [RouterModule],
  declarations: [UserDropdownMenuComponent],
  exports: [UserDropdownMenuComponent]
})

export class UserDropdownMenuModule {
 
}



// WEBPACK FOOTER //
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/user/user-dropdown-menu/user-dropdown-menu.module.ts